import { bootstrapApplication } from '@angular/platform-browser'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { ScheduleRecurrenceModule } from './app/_pages/schedule-recurrence/schedule-recurrence.module'

platformBrowserDynamic()
  .bootstrapModule(ScheduleRecurrenceModule)
  .catch(err => console.error(err))

bootstrapApplication(AppComponent, appConfig)
  .then()
  .catch(err => console.error(err))
